export default "__VITE_ASSET__dd8c4244__"